import React from 'react';

import image from '../images/tux.png';
import kernel from '../images/blurred/kernel.png';
import blurred from '../images/blurred/1.png';

import './convolution.css';

function LabelledImage({source, size, alt, label}) {
    const mobileFactor = 0.7
    return <div className='labelled-image'>
        <img src={source} width={size} height={size} alt={alt} className='desktop'/>
        <img src={source}
            width={mobileFactor * size} height={mobileFactor * size} 
            alt={alt} className='mobile'
        />
        <p className='label'>{`\\(${label}\\)`}</p>
    </div>
}

export default () => {
    return <div className='convolution-diagram'>
        <LabelledImage source={image} size={128} alt='Original' label='I_0'/>
        <p className='operator'>\(*\)</p>
        <LabelledImage source={kernel} size={50} alt='Gaussian Kernel' label='K'/>
        <p className='operator'>\(=\)</p>
        <LabelledImage source={blurred} size={128} alt='Blurred Once' label='I_1 = I_0 * K'/>
    </div>;
}
